import React, { useState } from 'react'
import SideNavBar from '../components/SideNavbar/SideNavBar';
import Header from '../components/header/Header';
import MainStream from "../components/stream/MainStream";
import MainCollage from "../components/collages/MainCollage";
import MainAdmissionType from "../components/admissionType/MainAdmissionType";
import MainCourses from "../components/courses/MainCourses";
import MainPaymentType from "../components/paymentType/MainPaymentType";
import MainFeesCollection from "../components/feesCollection/MainFeesCollection";
import MainExpenses from "../components/expenses/MainExpenses";
import MainStudents from "../components/students/MainStudents";
import MainEnrollment from "../components/enrollment/MainEnrollment";
import MainTutor from '../components/tutor/MainTutor';
import MainUser from '../components/user/MainUser';
import MainRole from '../components/role/MainRole';
import CollegeWise from '../components/reports/CollegeWise';
import CourseWise from '../components/reports/CourseWise';
import AdmissionTypeWise from '../components/reports/AdmissionTypeWise';
import CustomReports from '../components/reports/CustomReports';
import FinanceReports from '../components/reports/FinanceReports';
import ViewFinanceReport from '../components/reports/ViewFinanceReport';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useTokenExpiryCheck } from '../hooks/useTokenExpiryCheck';

const Dashboard = () => {
  let [showSideNav,setShowSideNav] = useState(false);
  useTokenExpiryCheck();
  return (
    <>
     <div className='relative bg-gray-100 h-screen text-gray-900 dark:bg-gray-900 dark:text-white'>
      <div className='absolute'>
        <SideNavBar showNav={showSideNav} setShowNav={setShowSideNav} />
      </div>
      <div className='grow ms-0 md:ms-0 lg:ms-56 bg-gray-100'>
        <Header showNav={showSideNav} setShowNav={setShowSideNav} />
      </div>
      <Routes>
          <Route path="/stream/*" element={<MainStream/>}></Route>
          <Route path="/collage/*" element={<MainCollage/>}></Route>
          <Route path="/admission-type/*" element={<MainAdmissionType/>}></Route>
          <Route path="/course/*" element={<MainCourses/>}></Route>
          <Route path="/payment-type/*" element={<MainPaymentType/>}></Route>
          <Route path="/fees-collection/*" element={<MainFeesCollection/>}></Route>
          <Route path="/expense/*" element={<MainExpenses/>}></Route>
          <Route path="/students/*" element={<MainStudents/>}></Route>
          <Route path="/enrollment/*" element={<MainEnrollment/>}></Route>
          <Route path="/staff/*" element={<MainTutor/>}></Route>
          <Route path="/user/*" element={<MainUser/>}></Route>
          <Route path="/role/*" element={<MainRole/>}></Route>
          <Route path="/college-wise-reports/*" element={<CollegeWise/>}></Route>
          <Route path="/course-wise-reports/*" element={<CourseWise/>}></Route>
          <Route path="/custom-reports/*" element={<CustomReports/>}></Route>
          <Route path="/finance-reports/*" element={<FinanceReports/>}></Route>
          <Route path="/view-finance-report/*" element={<ViewFinanceReport/>}></Route>
          <Route path="/admission-type-wise-reports/*" element={<AdmissionTypeWise/>}></Route>
        </Routes>
    </div> 

    </>
  )
}

export default Dashboard
